import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white shadow-xl rounded-lg p-8 max-w-md w-full" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = {
  key: 0,
  class: "mb-4 p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-2xl font-bold text-foreground mb-6 text-center" }, "Register", -1)),
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("label", {
          for: "fullname",
          class: "block text-foreground text-sm font-medium mb-2"
        }, "Full Name", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "fullname",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullname) = $event)),
          class: "w-full px-3 py-2 border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
          placeholder: "Enter your full name",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.fullname]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          for: "email",
          class: "block text-foreground text-sm font-medium mb-2"
        }, "Email", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
          class: "w-full px-3 py-2 border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
          placeholder: "Enter your email",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[9] || (_cache[9] = _createElementVNode("label", {
          for: "username",
          class: "block text-foreground text-sm font-medium mb-2"
        }, "Username", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "username",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.username) = $event)),
          class: "w-full px-3 py-2 border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
          placeholder: "Choose a username",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          for: "password",
          class: "block text-foreground text-sm font-medium mb-2"
        }, "Password", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
          class: "w-full px-3 py-2 border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
          placeholder: "Choose a password",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("label", {
          for: "confirmPassword",
          class: "block text-foreground text-sm font-medium mb-2"
        }, "Confirm Password", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "confirmPassword",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
          class: "w-full px-3 py-2 border border-input rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
          placeholder: "Confirm your password",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.confirmPassword]
        ])
      ]),
      (_ctx.validationError || _ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.validationError || _ctx.error.message), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: "w-full bg-secondary hover:bg-secondary/90 text-secondary-foreground font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out mb-4",
        disabled: _ctx.loading
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Registering..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, "Register"))
      ], 8, _hoisted_8),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.switchToLogin && _ctx.switchToLogin(...args))),
          class: "text-primary hover:text-primary/80 text-sm font-medium"
        }, " Already have an account? Login ")
      ])
    ], 32)
  ]))
}